import { DataSourceOptions, SymbolLayerOptions } from 'azure-maps-control';

const numberEmOffset = [0, -1.45]; // NOSONAR
const blackMarkerId = 'marker-cop-black';
const redMarkerId = 'marker-cop-red';

export const groupNumberSymbolLayerOptions: SymbolLayerOptions = {
  filter: ['has', 'point_count'], // Only show number on clusters, not individual pins
  iconOptions: {
    image: 'none'
  },
  textOptions: {
    allowOverlap: true,
    anchor: 'bottom',
    color: '#FFFFFF',
    font: ['SegoeUi-Bold'],
    offset: numberEmOffset,
    optional: true,
    size: 18,
    textField: ['get', 'point_count_abbreviated']
  }
};

export const groupMarkerSymbolLayerOptions: SymbolLayerOptions = {
  filter: ['has', 'point_count'],
  iconOptions: {
    allowOverlap: true,
    image: blackMarkerId,
    optional: true,
    size: 1.5,
    ignorePlacement: false
  }
};

export const singleMarkerSymbolLayerOptions: SymbolLayerOptions = {
  filter: ['!', ['has', 'point_count']],
  iconOptions: {
    allowOverlap: true,
    image: ['case', ['get', 'isActive'], redMarkerId, blackMarkerId],
    optional: true,
    size: 1,
    ignorePlacement: false
  }
};

export const individualSymbolLayerOptions: SymbolLayerOptions = {
  filter: ['!', ['has', 'point_count']],
  iconOptions: {
    allowOverlap: true,
    image: ['case', ['get', 'isActive'], redMarkerId, blackMarkerId],
    optional: true,
    size: 1,
    ignorePlacement: false
  }
};

export const dataSourceOptions: DataSourceOptions = {
  cluster: true,
  clusterMaxZoom: 18, // Allow clusters to split at higher zoom levels
  clusterRadius: 35   // Smaller radius = less aggressive clustering
};
